﻿const popupNav = {
  init: function() {
    this.popupNav = document.getElementById("popup_nav");
    this.popupTrigger = document.getElementsByClassName("popup-trigger");
    this.notSelected = document.getElementById("popupTrigger");

    this.events();
  },

  events: function() {
    if (this.popupNav != null) {

        window.addEventListener("mouseover", e => {
            var target = e.target
            if (target.closest(".header__buttons") && !target.closest(".header__buttons .button--transparent")) {
                this.addClass();
            }
            else {
                this.removeClass();
            }
        })//,
      /*
      window.addEventListener("click", e => {
        if (this.popupNav.classList.contains("show")) {
          if (
            !this.popupNav.contains(e.target) &&
            !this.notSelected.contains(e.target)
          ) {
            this.removeClass();
          }
        }
      });
  
      for (var i = 0; i < this.popupTrigger.length; i++) {
        this.popupTrigger[i].addEventListener("click", () => {
          this.toggleClass();
        });
      }
      */
    }
  },

  toggleClass: function() {
    this.popupNav.classList.toggle("show");
  },

  addClass: function () {
    this.popupNav.classList.add("show");
  },

  removeClass: function() {
    this.popupNav.classList.remove("show");
  }
};

export default popupNav.init();
